import {
  AmazonPaymentServiceConfig,
  ApplePaymentServiceConfig,
  BookkeeperConfig,
  GooglePaymentServiceConfig,
  Store,
  StoreCurrency,
} from '@playq/services-bookkeeper';
import { Environment } from '@playq/octopus-common';

export function createBlankBookkeeperConfiguration(env: Environment): BookkeeperConfig {
  const cfg = new BookkeeperConfig();
  cfg.ignorePaymentFailures = true;
  cfg.ignorePaymentValidation = false;
  cfg.allowPaymentsMigration = false;
  cfg.anchorCurrency = StoreCurrency.USD;

  const amazonCfg = new AmazonPaymentServiceConfig();
  const googleCfg = new GooglePaymentServiceConfig();
  const appleCfg = new ApplePaymentServiceConfig();

  if (env === Environment.Sandbox) {
    amazonCfg.verificationUri =
      'https://appstore-sdk.amazon.com/version/1.0/verifyReceiptId/developer/<developerSecret>/user/<userId>/receiptId/<receiptId>';
    googleCfg.verificationUri =
      'https://www.googleapis.com/androidpublisher/v3/applications/<packageName>/purchases/products/<productId>/tokens/<token>';
    googleCfg.tokenRefreshUri = 'https://accounts.google.com/o/oauth2/token';
    appleCfg.verificationUri = 'https://sandbox.itunes.apple.com/verifyReceipt';
  } else {
    amazonCfg.verificationUri =
      'https://appstore-sdk.amazon.com/version/1.0/verifyReceiptId/developer/<developerSecret>/user/<userId>/receiptId/<receiptId>';
    googleCfg.verificationUri =
      'https://www.googleapis.com/androidpublisher/v3/applications/<packageName>/purchases/products/<productId>/tokens/<token>';
    googleCfg.tokenRefreshUri = 'https://accounts.google.com/o/oauth2/token';
    appleCfg.verificationUri = 'https://buy.itunes.apple.com/verifyReceipt';
  }

  cfg.verificationConfigs = {
    [Store.AppStore]: appleCfg,
    [Store.GooglePlay]: googleCfg,
    [Store.AmazonMarketplace]: amazonCfg,
  };

  return cfg;
}
